import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { Provider } from "react-redux";
import store from "./store";
import ErrorBoundary from "./components/Common/ErrorBoundary";
import { installGlobalErrorHandlers } from "./helpers/errorReporter";
import { datadogRum } from '@datadog/browser-rum';

if(false && process.env.REACT_APP_BACKEND_API_URL != 'http://localhost:8012/api') {
  datadogRum.init({
      applicationId: '8879b674-5ac2-4fcb-ba3f-c8eedbbebfce',
      clientToken: 'pub4b7955d9654a2f1548f3e06a42683779',
      site: 'datadoghq.com',
      service: 'logistic2',
      env: 'PROD',
      // Specify a version number to identify the deployed version of your application in Datadog 
      // version: '1.0.0', 
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
  });
}

// Errores fuera del arbol de React (callbacks, timers, promesas). El
// ErrorBoundary solo ve los de render, asi que sin esto se pierden.
installGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.Fragment>
      <ErrorBoundary variant="app">
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
    </React.Fragment>
  </Provider>
);
